import React from "react";
import useModal from "use-react-modal";
import EducationModal from "./EducationModal";

const Education: React.FC = () => {
  const { isOpen, openModal, closeModal, Modal } = useModal();
  return (
    <section className="education" id="education">
      <div className="container">
        <h2 className="text-center text-uppercase text-secondary mb-0">
          Education
        </h2>
        <hr className="star-dark mb-5" />
        <div className="row">
          <div className="col-md-12  align-self-center col-lg-12">
            <a
              className="portfolio-item d-block mx-auto"
              href="#education"
              onClick={openModal}
            >
              <h2 style={{ textAlign: "center" }}>
                Technical University Of Kenya
              </h2>
            </a>
          </div>
        </div>
        {isOpen && (
          <Modal>
            <EducationModal close={closeModal} />
          </Modal>
        )}
      </div>
    </section>
  );
};

export default Education;
